exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".app-date-range-picker .app-date-range-picker-datepicker {\n  display: flex;\n}\n.app-date-range-picker .app-date-range-picker-datepicker .app-date-range-picker-tooltip-initial {\n  position: absolute;\n  margin-left: 2.5rem;\n}\n.app-date-range-picker .app-date-range-picker-datepicker .app-date-range-picker-tooltip-end {\n  position: absolute;\n  margin-left: 3.5rem;\n}\n", ""]);

// exports
